// extracted by mini-css-extract-plugin
export default {"root":"src__modules__common__patient-app__root"};